import { INVENTORY_SETTING_SUBMIT_RULES } from "@modules/inventory/inventory-setting/constants";

export const STOCK_SETTING_SUBMIT_RULES = (values, isStockReserveInstalled) => {
  const rules = {
    defaultValuationMethod: {
      required: true,
    },
    warehouseChartAccount: {
      type: "object",
      value: {
        required: true,
      },
    },
  };
  if (isStockReserveInstalled) {
    return {
      ...rules,
      ...INVENTORY_SETTING_SUBMIT_RULES,
    };
  }
  return rules;
};

export const READ_STOCK_SETTING = 204017;
export const UPDATE_STOCK_SETTING = 204018;

export const STOCK_SETTING_PATH = "/inventory/stock/stock-setting";
